// import React from 'react';
// import ReactDOM from 'react-dom'
// import App from './App';


// ReactDOM.rander(
//    <App />
//   ,document.getElementById('root')
// )

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './style.css';




ReactDOM.render(
  <App />
  ,document.getElementById('root')
)